import {
  Box,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import CustomInput from '../../../../components/customInput/CustomInput';
type IProps = {
  quantity: number;
  unit: string;
  weight: number;
  length: number;
  height: number;
  width: number;
  setQuantity: (a: number) => void;
  setUnit: (a: string) => void;
  setWeight: (a: number) => void;
  setLength: (a: number) => void;
  setHeight: (a: number) => void;
  setWidth: (a: number) => void;
};
function Shippings({
  quantity,
  unit,
  weight,
  length,
  height,
  width,
  setQuantity,
  setUnit,
  setWeight,
  setLength,
  setHeight,
  setWidth,
}: IProps) {
  const t = useTranslate();

  return (
    <>
      <Typography variant='subtitle1'>{t('shippings')}</Typography>
      <CustomInput
        defaultValue={quantity}
        name='quantity'
        type='number'
        label={t('quantity')}
        onBlur={(e) => setQuantity(parseFloat(e.target.value))}
      />
      <CustomInput defaultValue={unit} label={t('unit')} name='unit' />
      <CustomInput
        defaultValue={weight}
        name='weight'
        type='number'
        label={t('weight')}
        unit={t('grams')}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setWeight(parseFloat(e.target.value))}
      />

      <CustomInput
        defaultValue={length}
        label={t('length')}
        type='number'
        unit={t('cm')}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setLength(parseFloat(e.target.value))}
      />
      <CustomInput
        defaultValue={height.toString()}
        name='height'
        label={t('height')}
        type='number'
        style={{
          width: '100%',
        }}
        unit={t('cm')}
        onBlur={(e) => setHeight(parseFloat(e.target.value))}
      />

      <CustomInput
        defaultValue={width}
        name='width'
        label={t('width')}
        type='number'
        unit={t('cm')}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setWidth(parseFloat(e.target.value))}
      />
    </>
  );
}

export default Shippings;
